import amex from 'url:Images/credit-cards/amex.svg';
import diners from 'url:Images/credit-cards/diners.svg';
import discover from 'url:Images/credit-cards/discover.svg';
import jcb from 'url:Images/credit-cards/jcb.svg';
import mastercard from 'url:Images/credit-cards/mastercard.svg';
import visa from 'url:Images/credit-cards/visa.svg';

export const CARDS = [
  {
    name: 'American Express',
    brand: 'amex',
    img: amex,
  },
  {
    name: 'Diners Club',
    brand: 'diners',
    img: diners,
  },
  {
    name: 'Discover',
    brand: 'discover',
    img: discover,
  },
  {
    name: 'JCB',
    brand: 'jcb',
    img: jcb,
  },
  {
    name: 'Mastercard',
    brand: 'mastercard',
    img: mastercard,
  },
  {
    name: 'Visa',
    brand: 'visa',
    img: visa,
  },
];

export function getCard(brand) {
  return CARDS.find((card) => card.brand === brand);
}
